// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit .tab-content-footer .tab-footer-value .applicability-field{color:#18171D}\n", ""]);
// Exports
module.exports = exports;
